import { useDialogState } from 'reakit';
/**
 * Controller allowing external players to control modals.
 */

/**
 * Returns an object containing functions allowing the
 *   implementer to control the modal.
 */
export var useModalController = function useModalController() {
  var state = useDialogState();
  return {
    show: state.show,
    hide: state.hide,
    toggle: state.toggle,
    state: state
  };
};